<template>
  <div id="pageContent">
    <TopBanner :bg-img="bgImg"
               :sub-title="mainTitle" />
    <TabDepthMenu :tab-list="tabList" />
    <router-view class="contents"></router-view>
  </div>
</template>

<script>
import TopBanner from '@/components/Common/TopBanner.vue';
import TabDepthMenu from '@/components/Common/TabDepthMenu.vue';

export default {
  name: 'YouthView',
  components: {TabDepthMenu, TopBanner},
  data() {
    return {
      bgImg: 'black', // youthList
      mainTitle: '유스',
      tabList: [],
    }
  },
  mounted () {
  },
  methods: {
  },
  created() {
    const menuList = this.$router.options.routes && this.$router.options.routes.filter(x => {
      return x.path === this.$route.matched[0].path ? x : '';
    });

    const subMenuList = menuList[0].children && menuList[0].children.filter(x => {
      return x.meta && x.meta.title;
    });

    Object.entries(subMenuList).forEach(([, value]) => {
      const result = {
        title: value.meta.title,
        name: value.name,
        isActive: this.$route.name === value.name
      }
      this.tabList.push(result);
    });
  },
}
</script>
